module.exports = __webpack_public_path__ + "static/media/main idea.6e7164bd.mp3";